import Home from '../pages/Home';
import Files from '../pages/Files';
import Upload from '../pages/Upload';
import ProviderProfile from '../pages/ProviderProfile';
import Exception from '../pages/Exception';
import PerformanceStandards from '../pages/PerformanceStandards';
import { PageLayout } from '../Layout/PageLayout';
import LogoutPage from '../pages/LogoutPage';
import SiteminderLoginPage from '../pages/SiteminderLoginPage';
import LoginErrorPage from '../pages/LoginErrorPage';
import TableauDashboardPage from '../pages/TableauDashboardPage';
import { DataImportNoticeComponent } from '../components/DataImportNoticeComponent/DataImportNoticeComponent';
import PfpHome from '../pages/PfpHome';
import PfpProviderProfile from '../pages/PfpProviderProfile';
import Unauthorized from '../pages/Unauthorized';
import ComingSoon from '../pages/ComingSoon';
import P4PDashboardPage from '../pages/P4PDashboardPage';
import MeasureDetailsComponent from '../components/MeasureDetails/MeasureDetailsComponent';
import Contact from '../pages/Contact';
import Help from '../pages/Help';
import TableauDashboard from '../pages/TableauDashboard';
import AdminConsolePage from '../pages/AdminConsolePage';
import NotFoundPage from '../pages/NotFoundPage';
import DataManagement from '../pages/DataManagement';
import { Constants } from './appConstants';
import { MainViewPage } from '../components/AppHeaderComponent/MainViewPage';

export const ROUTES = [
  {
    path: '/pages/home',
    element: (
      <PageLayout>
        <MainViewPage />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/home',
    element: (
      <PageLayout>
        <Home />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/dashboard',
    element: (
      <PageLayout>
        <Home />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/files',
    element: (
      <PageLayout>
        <Files />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/upload',
    element: (
      <PageLayout>
        <Upload />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [
      Constants.ADMIN_GROUP_NAME,
      Constants.SUPER_ADMIN_GROUP_NAME,
    ],
  },
  {
    path: '/provider',
    element: (
      <PageLayout>
        <ProviderProfile />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/login',
    element: <SiteminderLoginPage />,
    allowedRoles: [],
  },
  {
    path: '/siteminder-login',
    element: <SiteminderLoginPage />,
    allowedRoles: [],
  },
  {
    path: '/standards',
    element: (
      <PageLayout>
        <PerformanceStandards />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/error',
    element: (
      <PageLayout>
        <Exception />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [
      Constants.ADMIN_GROUP_NAME,
      Constants.SUPER_ADMIN_GROUP_NAME,
    ],
  },
  {
    path: '/logout',
    element: <LogoutPage />,
    allowedRoles: [],
  },
  {
    path: '/login-error',
    element: <LoginErrorPage />,
    allowedRoles: [],
  },
  {
    path: '/executive-dashboard',
    element: <TableauDashboard />,
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/pfp/providers',
    element: (
      <PageLayout>
        <PfpHome />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/pfp/providerProfile',
    element: (
      <PageLayout>
        <PfpProviderProfile />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/unauthorized',
    element: <Unauthorized />,
    isPrivate: false,
    allowedRoles: [],
  },
  {
    path: '/tableau',
    element: (
      <PageLayout>
        <TableauDashboardPage />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/p4p/dashboard',
    element: (
      <PageLayout>
        <P4PDashboardPage />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/coming-soon',
    element: (
      <PageLayout>
        <ComingSoon />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/help',
    element: (
      <PageLayout>
        <Help />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/contact',
    element: (
      <PageLayout>
        <Contact />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/users',
    element: (
      <PageLayout>
        <ComingSoon />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/',
    element: <SiteminderLoginPage />,
    allowedRoles: [],
  },
  {
    path: '/dataupload/:tab',
    element: (
      <PageLayout>
        <DataImportNoticeComponent />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/measureDetails',
    element: (
      <PageLayout>
        <MeasureDetailsComponent />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [],
  },
  {
    path: '/admin-console',
    element: (
      <PageLayout>
        <AdminConsolePage />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [Constants.SUPER_ADMIN_GROUP_NAME],
  },
  {
    path: '/data-management',
    element: (
      <PageLayout>
        <DataManagement />
      </PageLayout>
    ),
    isPrivate: true,
    allowedRoles: [Constants.SUPER_ADMIN_GROUP_NAME],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];